import { NavLink, useLocation } from 'react-router-dom';
import { sidebarNavItems } from '@/lib/nav';

export default function BottomDock() {
  const location = useLocation();

  return (
    <div className="fixed bottom-0 left-0 right-0 flex justify-center z-30 pointer-events-none">
      <nav className="pointer-events-auto mb-4 flex items-center gap-1 px-3 py-3 rounded-2xl bg-primary-500/90 backdrop-blur-xl border border-primary-400/30 shadow-[0_2px_24px_rgba(3,82,95,0.3)]">
        {sidebarNavItems.map((item) => {
          const isActive = item.path === '/dashboard'
            ? (location.pathname === '/' || location.pathname === '/dashboard')
            : location.pathname.startsWith(item.path);

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center gap-1 min-w-[4.5rem] h-14 px-2 rounded-xl transition-all duration-200 cursor-pointer ${
                isActive
                  ? 'bg-background-50 text-primary-600 scale-105'
                  : 'text-primary-200 hover:text-background-50 hover:bg-primary-400/40'
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <span className="text-[10px] font-medium leading-none whitespace-nowrap">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
